/* eslint-env browser */
import { NAVIGATION_OFFSET_SELECTOR } from 'Components/widgets/navigation/Navigation.constants';

export function goToHash(hash, scrollUnderNav = true, behavior = 'auto') {
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */
  function scrollUnderNavBar() {
    const navBar = document.querySelector(NAVIGATION_OFFSET_SELECTOR);

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    setTimeout(() => {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior });
        if (scrollUnderNav) {
          scrollUnderNavBar();
        }
      }
    }, 100);
  }
}
